import { Component, Inject, OnInit } from '@angular/core';
import { ACHRecordService } from 'src/app/services/ach_record_service';
import { ACHRecord } from 'src/app/models/ach_record.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatNoDataRow } from '@angular/material/table';
import { MatIconButton } from '@angular/material/button';
import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { MatIcon } from '@angular/material/icon';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'ach-record-dialog',
    templateUrl: './ach_record_dialog.component.html',
    styleUrls: ['./ach_record_dialog.component.scss'],
    imports: [MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatIconButton, CdkCopyToClipboard, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatNoDataRow, DatePipe]
})

  export class ACHRecordDialogComponent implements OnInit {

    achRecords: ACHRecord[] = [];
    displayedColumns: string[] = ['Bank Name', 'Account Number', 'Routing Number', 'Create Date'];

    constructor(
        private achRecordService: ACHRecordService,
        public dialogRef: MatDialogRef<ACHRecordDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: string) {}

    ngOnInit(): void {
        this.getCustomersACHRecords();
    }

    getCustomersACHRecords(): void {
        const map = new Map();
        map.set('userId', this.data );
        this.achRecordService
            .getAll([], map )
            .subscribe(achRecords => {
                this.achRecords = achRecords;
            });
        }

}
